import React, { useEffect, useState, useRef } from 'react';
import { useMutation } from '@tanstack/react-query';
import CircularProgress from '@mui/material/CircularProgress';
import { useUser } from '../../context/UserContext';
import { LoginFastEapp } from '../../api/fast';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

// return eAppIcon

export default function FASTLinkIcon({ ...props }) {
  const user = useUser();
  const [fastData, setFastData] = useState(null);
  const [open, setOpen] = useState(false);

  const openFASTURL = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    FASTURL.mutate();
  };

  function checkLOB(iD3Code) {
    var isValid = user.LOB.find((o) => o.ProductCode == iD3Code);
    return isValid != null && isValid != undefined;
  }

  const FASTURL = useMutation({
    mutationFn: async () => await LoginFastEapp()(),
    gcTime: 0, // Renamed from cacheTime in v5
  });

  // Handle success with useEffect
  useEffect(() => {
    if (FASTURL.isSuccess && FASTURL.data) {
      setFastData(FASTURL.data);
    }
  }, [FASTURL.isSuccess, FASTURL.data]);

  const [errorTimer, setErrorTimer] = useState(false);

  useEffect(() => {
    if (fastData?.postBackUrl) {
      document.forms['frmFAST' + props.id].submit();
    }
  }, [fastData]);

  useEffect(() => {
    if (FASTURL.isError) {
      setTimeout(() => {
        setErrorTimer(true);
      }, 3000);
    }
  }, [FASTURL.isError]);

  if (FASTURL.isError && !FASTURL.isPending) {
    if (errorTimer) {
      return (
        <li style={{ listStyle: 'none' }}>
          <a
            onClick={() => {
              openFASTURL();
            }}
          >
            Click to retry
          </a>
        </li>
      );
    }
    return (
      <li style={{ listStyle: 'none' }}>
        <a>Could not generate FAST Link</a>
      </li>
    );
  }

  return (
    <>
      <a onClick={openFASTURL}>
        <img src="/images/eApp.png" title="eApp" alt="eApp Icon" />
        {FASTURL.isPending && <CircularProgress size={16} />}
        {fastData && (
          <form
            action={fastData?.postBackUrl}
            id={'frmFAST' + props.id}
            target="_blank"
            method="POST"
          >
            <input
              type="hidden"
              id="SAMLResponse"
              name="SAMLResponse"
              value={fastData?.samlResponse ?? ''}
            />
            <input
              type="hidden"
              id="RelayState"
              name="RelayState"
              value={fastData?.relayUrl ?? ''}
            />
          </form>
        )}
      </a>
      <Dialog
        open={open}
        onClose={handleClose}
        disableEscapeKeyDown
        PaperProps={{ className: 'pdf-modal' }}
      >
        <DialogTitle>Acknowledge PDF to Continue Logging In</DialogTitle>
        <DialogContent>
          <h4>An Agent is not permitted to sign for the insured or owner, even if</h4>
          <ul>
            <li>
              they have prior or real time verbal or written authorization from the client; and/or
            </li>
            <li>they are on a screen sharing call with the client at the time of application</li>
          </ul>
          <object
            data="/images/eAppSignatureMethodOption1.pdf"
            type="application/pdf"
            width="100%"
            height="550px"
          >
            <p>
              Unable to display PDF file.{' '}
              <a href="/images/9104ElectronicSignature Rules.pdf">Download</a> instead.
            </p>
          </object>
        </DialogContent>
        <DialogActions>
          <button className="btn btn-danger" type="button" onClick={handleClose}>
            Acknowledge
          </button>
        </DialogActions>
      </Dialog>
    </>
  );
}
